import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from '../styles/infoBox.module.scss';

const InfoBox = ({ children, className = '' }) => (
  <div className={classnames(styles.element, className)}>
    {children}
  </div>
);

InfoBox.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default InfoBox;
